import { ReducerAction } from 'types/reducer';

import { HotelListRequest, HotelListResponse } from 'proto/Api/Hotel/HotelList';

import { HotelListView } from '../../component/Accommodation/List/__partials/List/types';

export enum AccommodationListAction {
    StartNewSearch = 'startNewSearch',
    PollError = 'pollError',
    PollTimeout = 'pollTimeout',
    PollUpdate = 'pollUpdate',
    PollFinished = 'pollFinished',
    UpdateAccommodationList = 'updateAccommodationList',
    UpdateLastClickedHotel = 'updateLastClickedHotel',
}

export enum StartNewSearchScope {
    Default = 'default',
    Initial = 'initial',
    Pagination = 'pagination',
    Destination = 'destination',
}

interface StartNewSearchData {
    searchUrl: string;
    clientId: string;
    transactionId: string;
    scope: StartNewSearchScope;
}

interface LastClickedHotel {
    id: number;
    name: string;
    isFeaturedHotel: boolean;
}

export type AccommodationListReducerAction =
    | ReducerAction<AccommodationListAction.StartNewSearch, StartNewSearchData>
    | ReducerAction<AccommodationListAction.PollError, boolean>
    | ReducerAction<AccommodationListAction.PollTimeout, boolean>
    | ReducerAction<AccommodationListAction.PollUpdate, void>
    | ReducerAction<AccommodationListAction.PollFinished, void>
    | ReducerAction<
          AccommodationListAction.UpdateAccommodationList,
          HotelListResponse
      >
    | ReducerAction<
          AccommodationListAction.UpdateLastClickedHotel,
          LastClickedHotel
      >;

export interface ActionMap {
    startNewSearch(searchUrl: string, scope?: StartNewSearchScope): void;
    onPollError(updatePending: boolean): void;
    onPollTimeout(updatePending: boolean): void;

    onPollUpdate(): void;

    onPollFinished(): void;

    updateAccommodationList(response: HotelListResponse): void;

    updateLastClickedHotel(
        id: number,
        name: string,
        isFeaturedHotel: boolean
    ): void;
}

export interface ReducerState {
    requestData: HotelListRequest;
    view: HotelListView;
    isLoading: boolean;
    responseData: HotelListResponse;
    pollingUrl: string;
    pollingFinished: boolean;
    listCallRunning: boolean;
    timeoutNotified: boolean;
    pendingRequest?: HotelListRequest;
    lastClickedHotel?: LastClickedHotel;
    searchStatus: StartNewSearchScope | null;
}
